const forceValidationDisable = (state, action) => {
  if (state === undefined) {
    return false;
  }

  switch (action.type) {
    case "SET_FORCE_VALIDATION_DISABLE":
      return action.payload;
    default:
      return state.forceValidationDisable;
  }
};

export { forceValidationDisable };
